import { DefectTrackerActions } from "./constant";
import { checkPermission } from "@/utils/permissionAndRoleCheck";

const defectTrackerScreenCode = "DEFEKT_TRACKER";

const permissionChecker = (action: string, hideParam?: string) => {
  return (permissions: any) => {
    return checkPermission(
      permissions,
      defectTrackerScreenCode,
      action,
      hideParam
    );
  };
};

const DEFEKT_TRACKER = {
  VIEW: permissionChecker(DefectTrackerActions.VIEW),
  CREATE: permissionChecker(DefectTrackerActions.CREATE),
  UPDATE: permissionChecker(DefectTrackerActions.UPDATE),
  DELETE: permissionChecker(DefectTrackerActions.DELETE),
  RENAME: permissionChecker(DefectTrackerActions.RENAME),
  CONNECT: permissionChecker(DefectTrackerActions.CONNECT),

  // hide permission
  HIDE_VIEW: permissionChecker(DefectTrackerActions.VIEW, "HIDE"),
  HIDE_CREATE: permissionChecker(DefectTrackerActions.CREATE, "HIDE"),
  HIDE_UPDATE: permissionChecker(DefectTrackerActions.UPDATE, "HIDE"),
  HIDE_DELETE: permissionChecker(DefectTrackerActions.DELETE, "HIDE"),
  HIDE_RENAME: permissionChecker(DefectTrackerActions.RENAME, "HIDE"),
  HIDE_CONNECT: permissionChecker(DefectTrackerActions.CONNECT, "HIDE"),
};

export default DEFEKT_TRACKER;
